import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

const useComponentTemplatesApi = () => {
  const listRoots = useCallback(async () => {
    const { data } = await axios.get(`${API_PATH}/liftlogic/component-templates`, {
      headers: authHeaders(),
    });
    return data; // { roots: [...] }
  }, []);
  const getTree = useCallback(async (rootId) => {
    const { data } = await axios.get(`${API_PATH}/liftlogic/component-templates/${rootId}/tree`, {
      headers: authHeaders(),
    });
    return data; // { tree: [...] }
  }, []);
  const createRoot = useCallback(async (name) => {
    const { data } = await axios.post(
      `${API_PATH}/liftlogic/component-templates`,
      { name },
      { headers: authHeaders() }
    );
    return data;
  }, []);
  const addNode = useCallback(async (rootId, payload) => {
    const { data } = await axios.post(
      `${API_PATH}/liftlogic/component-templates/${rootId}/nodes`,
      payload,
      { headers: authHeaders() }
    );
    return data;
  }, []);
  const updateNode = useCallback(async (nodeId, payload) => {
    const { data } = await axios.put(
      `${API_PATH}/liftlogic/component-templates/${nodeId}`,
      payload,
      { headers: authHeaders() }
    );
    return data;
  }, []);
  const removeNode = useCallback(async (nodeId) => {
    const { data } = await axios.delete(`${API_PATH}/liftlogic/component-templates/${nodeId}`, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  return useMemo(
    () => ({ listRoots, getTree, createRoot, addNode, updateNode, removeNode }),
    [listRoots, getTree, createRoot, addNode, updateNode, removeNode]
  );
};

export default useComponentTemplatesApi;
